import * as Types from '../api';

import { gql } from '@apollo/client';
export type MeetingListFragment = { __typename?: 'Meeting', summary: string, startTime: any, length?: number | null, roomId: string, pinCode?: string | null, allowUnmute: boolean };

export const MeetingListFragmentDoc = gql`
    fragment MeetingList on Meeting {
  summary
  startTime
  length
  roomId
  pinCode
  allowUnmute
}
    `;